@if (isNotIso27701()) {
	<div class="client-property-label">
		<span>{{ 'additional-questions.outsources-processes.question' | translate }}</span>
		<change-label [visible]="areOutsourcedProcessesChanged()" [changeSet]="changeSet"></change-label>
	</div>
	<div class="client-property">
		@for (process of product.additionalQuestions.outsourcedProcesses; track $index; let isLast = $last) {
			<span>{{ translate(process) | async }}{{ isLast ? '&nbsp;' : ',&nbsp;' }}</span>
		}
		@if (translationVisible('additionalQuestions.customOutsourcedProcess')) {
			<translation-field [standard]="standardName()"
							   [translationSubject]="'additionalQuestions.customOutsourcedProcess'" [previewMode]="!translateClientsData"
							   [translatedText]="getTranslatedText('additionalQuestions.customOutsourcedProcess')"></translation-field>
		}
	</div>
}

@for (question of binaryQuestions(); track trackByBinaryQuestion(i, question); let i = $index) {
	<div class="form-row with-padding-bottom radio-row">
		<div class="radio-with-question">
			<div class="radio-column">
				<nb-radio [name]="'radio-question-' + i + '-' + RANDOM_NUMBER" [checked]="true" status="primary">
					{{ question.answer | booleanDisplay }}
				</nb-radio>
			</div>
			<div class="radio-description-column">
				<span>{{ question.question }}</span>
				<change-label [visible]="isBinaryQuestionChanged(question)" [changeSet]="changeSet"></change-label>
			</div>
		</div>
		@if (question.description) {
			<div style="display: flex;">
				<div class="radio-column"></div>
				<div class="radio-description-column bold">
					{{ question.description }}
				</div>
			</div>
			@if (binaryQuestionTranslationVisible(question)) {
				<div class="translation-wrapper">
					<translation-field [standard]="standardName()" [previewMode]="!translateClientsData"
									   [translatedText]="getBinaryQuestionTranslatedText(question)" [translationSubject]="getTranslationSubjectForBinaryQuestion(question)"></translation-field>
				</div>
			}
		}
	</div>
}

@for (group of textQuestions() | async | keyvalue; track trackByTextQuestion($index, group)) {
	@for (question of group.value; track question.type; let i = $index) {
		<div>
			@if (question.group !== 'DEFAULT' && i == 0) {
				<div class="group-label">
					<label>{{ getGroupName(question.group) | async }}</label>
				</div>
			}
			<div class="client-property-label">
				<span>{{ question.question?.toUpperCase() }}</span>
				<change-label [visible]="isTextQuestionChanged(question)" [changeSet]="changeSet"></change-label>
			</div>
			<div class="client-property">
				{{ question.answer }}
				@if (textQuestionTranslationVisible(question)) {
					<translation-field [standard]="standardName()" [previewMode]="!translateClientsData"
									   [translatedText]="getTextQuestionTranslatedText(question)" [translationSubject]="getTranslationSubjectForTextQuestion(question)"></translation-field>
				}
			</div>
		</div>
	}
}
